import { EColor } from '@frontend/pole-ui/lib/common/constants'
import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const harvestSaleLotsPreviewSkeletons: TSkeletons = [
  ...Array(3).fill({
    className: 'harvest-sale-lot-preview row row_column',
    height: null,
    width: null,
    backgroundColor: EColor.WHITE,
    skeletons: [
      { className: 'space-holder2 text_small', backgroundColor: EColor.LIGHT_GRAY, width: '33.33%' },
      { className: 'space-holder16 text_small', backgroundColor: EColor.LIGHT_GRAY, width: '50%' },
      { className: 'space-holder16 text_small', height: '2.81em', backgroundColor: EColor.LIGHT_GRAY },
      { width: '50%', backgroundColor: EColor.LIGHT_GRAY },
      { className: 'space-holder16 space-holder-top2', height: '2em', backgroundColor: EColor.LIGHT_GRAY },
      {
        height: null,
        skeletons: [
          { height: '2.81em', width: '50%', backgroundColor: EColor.LIGHT_GRAY },
          {
            height: '2.81em',
            className: 'space-holder-left16',
            width: 'calc(50% - 16px)',
            backgroundColor: EColor.LIGHT_GRAY,
            style: { borderRadius: '40px' },
          },
        ],
      },
    ],
  }),
  {
    width: '210px',
    height: '2.81em',
    style: { borderRadius: '40px' },
    className:
      'space-holder-top16 space-holder-left-auto-sm space-holder-right-auto-sm harvest-sale-lots-preview-container__more-lots-link',
    backgroundColor: EColor.WHITE,
    additionalColor: EColor.LIGHT_GRAY,
  },
]
